import { Heart } from "lucide-react"

export const HeartIcon = ({
  isFavorite = false,
  onClick
}: {
  isFavorite?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}) => (
  <Heart
    className={`w-4 h-4 text-red-500 ${isFavorite ? "fill-red-500" : ""} ${onClick ? "cursor-pointer hover:scale-110 transition-transform" : ""}`}
    onClick={onClick}
  />
);